import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
 
import { CardDeck, Row, Col, Container, Card,Table } from 'react-bootstrap'
 

class VRNBox extends React.Component {
    constructor(props) {
        super(props);
        
    }
    
    render() {
        return (
            <section id="carousel-options">
            <div className="row match-height">
                <div className="col-md-8 col-sm-12">

                
                <Card className="card text-center">
                    <Card.Title className="card-header">
                    </Card.Title>
                    <Card.Body>
                    <div className="col-md-6 col-12">
                        <div className="form-label-group">
                                <Table>
                                    <Row>
                                       <Col>
                                            <label>VRN</label>
                                       </Col>
                                       <Col>
                                            <label>{this.props.vrn}</label> 
                                       </Col>
                                     
                                    </Row>
                                    {/* <Row>
                                      <label>VRN</label><label>{this.props.vrn}</label> 
                                    </Row> */}
                                </Table>
                                {/* <label id="lblVRN">{this.props.vrn}</label>
                                <label id="lblManufacturer ">{this.props.mfg}</label>
                                <label id="lblModel ">{this.props.model}</label>
                                <label id="lblType ">{this.props.type}</label>
                                <label id="lblVRN ">{this.props.vrn}</label> */}
                        </div>
                    </div>
                    </Card.Body>
                </Card>
                </div>
            </div>
            </section>
        );
    }
}

export default VRNBox;